import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class JwtService {

  constructor() { }
   // Decode JWT Token
  //  decodeToken(token: string): any {
  //   const parts = token.split('.');
  //   if (parts.length !== 3) {
  //     return null;
  //   }
  //   const payload = parts[1]; // The payload is the middle part
  //   const decoded = CryptoJS.enc.Base64.parse(payload).toString(CryptoJS.enc.Utf8);
  //   return JSON.parse(decoded);
  // }

 decodeToken(token: string): any {
  const parts = token.split('.');
  if (parts.length !== 3) return null;

  try {
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const pad = base64.length % 4;
    if (pad === 2) base64 += '==';
    else if (pad === 3) base64 += '=';

    const binaryString = window.atob(base64);
    const codePoints = [];
    for (let i = 0; i < binaryString.length; i++) {
      codePoints.push(binaryString.charCodeAt(i));
    }
    const jsonString = String.fromCharCode.apply(null, codePoints);
    const cleanJsonString = decodeURIComponent(escape(jsonString));
    
    // RETURN DATA WITHOUT TOUCHING data.Menu!
    // Leave data.Menu exactly as the raw string the backend sent.
    return JSON.parse(cleanJsonString); 
  } catch (error) {
    console.error("Legacy JWT Decoder failed:", error);
    return null;
  }
}

  // Check if the token is expired
  isTokenExpired(token: string): boolean {
    const decoded = this.decodeToken(token);
    if (decoded && decoded.exp) {
      const expDate = decoded.exp * 1000; // exp is in seconds, so we multiply by 1000 to convert to milliseconds
      return Date.now() >= expDate;
    }
    return true; // If no expiration or invalid token, we consider it expired
  }

  // Check if the token is valid (you should ideally use backend for full validation)
  isValidToken(token: string): boolean {
    // Check if the token is expired
    // return !this.isTokenExpired(token);
    return true;
  }
}
